"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VentaConverter = void 0;
const VentaConverter = {
    toFirestore(venta) {
        return venta;
        // const obj: any = venta;
        // if (obj.buscablePor != null) {
        //   obj.query = generarCampoBusqueda({ buscableParcialPor: obj.buscablePor, buscableExactoPor: [obj.id] });
        // }
        // return obj;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            version: data.version,
            id: data.id,
            idBorrador: data.idBorrador ?? "",
            formaDePago: data.formaDePago,
            fechaComprobante: data.fechaComprobante,
            fechaCreacion: data.fechaCreacion,
            comprobante: data.comprobante,
            cliente: data.cliente,
            moneda: data.moneda,
            descuentoGeneral: data.descuentoGeneral,
            ventaLinea: data.ventaLinea,
            subtotal: data.subtotal,
            montoIVA: data.montoIVA,
            redondeo: data.redondeo,
            total: data.total,
            totalRetenciones: data.totalRetenciones,
            saldo: data.saldo,
            activo: data.activo,
            esDeExportacion: data.esDeExportacion,
            exportacionClausulaVenta: data.exportacionClausulaVenta,
            exportacionModalidadVenta: data.exportacionModalidadVenta,
            exportacionViaTransporte: data.exportacionViaTransporte,
            usuario: data.usuario,
            local: data.local,
            listasPreciosServicios: data.listasPreciosServicios,
            listasPreciosProductos: data.listasPreciosProductos,
            buscablePor: data.buscablePor,
            cotizacion: data.cotizacion,
            esPagoCuentaTerceros: data.esPagoCuentaTerceros,
            productosYservicios: data.productosYservicios,
            tipo: data.tipo,
            periodoDesdeHasta: data.periodoDesdeHasta,
            periodoDesde: data.periodoDesde ?? "",
            periodoHasta: data.periodoHasta ?? "",
            ordenCompra: data.ordenCompra,
            listaFormaDePago: data.listaFormaDePago,
            fechaVencimiento: data.fechaVencimiento,
            modalidadVentaInfo: data.modalidadVentaInfo,
            infoAdicional: data.infoAdicional,
            ventaLineaImpresion: data.ventaLineaImpresion,
            cobros: data.cobros,
            pagos: data.pagos,
            tipoDevolucion: data.tipoDevolucion,
            detalleDevolucion: data.detalleDevolucion,
            detalleDevolucionImporte: data.detalleDevolucionImporte,
            cfeId: data.cfeId,
            cfeNumero: data.cfeNumero,
            cfeSerie: data.cfeSerie,
            cfeTipo: data.cfeTipo,
            cfeMotivoRechazoDGI: data.cfeMotivoRechazoDGI,
            cfeMotivoRechadoReceptor: data.cfeMotivoRechadoReceptor,
            cfeEstadoDGI: data.cfeEstadoDGI,
            cfeEstadoReceptor: data.cfeEstadoReceptor,
            adenda: data.adenda,
            comprobanteCancelante: data.comprobanteCancelante,
            comprobanteCancelado: data.comprobanteCancelado,
            vendedor: data.vendedor,
            cuentaAjena: data.cuentaAjena,
            remitos: data.remitos ?? [],
            esContingencia: data.esContingencia ?? false,
            creadaDesde: data.creadaDesde ?? "",
            origen: data.origen ?? "",
            literalE: data.literalE ?? false
        };
    }
};
exports.VentaConverter = VentaConverter;
